import useAuthContext from "./useAuthContext";
import { Permission } from "../components/auth-context-provider";

export const useHasPermission = (permission: Permission) => {
  console.log("====================11111111111111111");
  console.log(useAuthContext()[2]);
  return useAuthContext()[2].hasPermission(permission);
};
